"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBankCard = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPay_1 = require("../../model/hsPay");
var service_1 = require("../../../library/base/service");
var CheckBankCard = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CheckBankCard, _super);
    function CheckBankCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '校验银行卡是否一致接口';
        _this.code = '105036';
        _this.desc = '校验银行卡是否一致接口';
        _this.requestParams = new hsPay_1.CheckBankCardRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CheckBankCard;
}(service_1.BaseService));
exports.CheckBankCard = CheckBankCard;
//# sourceMappingURL=checkBankCard.js.map